/* ============================================================
   BONHEUR - Guardia del carrito lateral
   BigStudio 2026

   POR QUE EXISTE ESTE ARCHIVO
   El carrito lateral es mejor experiencia: confirma que la
   pieza entro sin sacar a nadie de la vitrina. Pero el modulo
   de entrega (retiro o despacho, comuna, fecha y hora) SOLO se
   dibuja en la pagina del carrito, dentro de la tarjeta del
   resumen. Si el boton del cajon saltara directo al checkout,
   entraria pedido sin fecha ni lugar de entrega, que en una
   pasteleria por encargo es un pedido perdido.

   Entonces: el cajon confirma y muestra el total, y su boton
   lleva a la bolsa, donde se elige la fecha y desde ahi se paga.
   Un paso mas, cero pedidos huerfanos.

   El guardia se desactiva SOLO si algun dia el modulo aparece
   dentro del cajon: en ese caso no hay nada que proteger.

   HISTORIA: hasta septiembre de 2026 esto buscaba a Zapiet,
   que era quien dibujaba el selector. Zapiet salio y lo
   reemplazo <bonheur-entrega>. Se dejan los selectores viejos
   de Zapiet en la lista por si el app embed reviviera en algun
   tema: si estuviera, tampoco habria que proteger nada.
   ============================================================ */

(function () {
  'use strict';

  var CAJON = '#cart-drawer';
  var SELECTOR_ENTREGA = 'bonheur-entrega,[id*="zapiet" i],[class*="zapiet" i],#storePickupApp,[data-zapiet]';
  var TEXTO_BOTON = 'Elegir fecha y pagar';
  var TEXTO_PASO = 'En el paso siguiente eliges retiro o despacho.';

  /* La linea del despacho no lleva a ninguna parte. Su nombre apunta a
     la ficha del producto interno de despacho, que el cliente no tiene
     por que ver y que ademas esta oculto del catalogo.

     OJO: NO se le toca el href. assets/bonheur-carrito.css usa ese
     mismo href para reconocer la fila y esconderle la cantidad y el
     basurero. Si se borrara, volverian a aparecer los dos.

     Si cambia el handle del producto, hay que cambiarlo en TRES
     lugares: aca, en esa hoja, y en el ajuste "Handle del producto de
     despacho" del modulo de entrega. */
  var RUTA_DESPACHO = '/products/despacho-a-domicilio';
  var ENLACE_DESPACHO = '.cart-items__table-row a[href*="' + RUTA_DESPACHO + '"]';

  function hayEntrega(cajon) {
    return !!cajon.querySelector(SELECTOR_ENTREGA);
  }

  /* El click se toma en captura para llegar antes que el envio
     del formulario del tema. La pagina del carrito NO se toca:
     ahi el boton paga de verdad, y quien decide si deja pasar
     es el propio modulo mas la seccion bonheur-guard. */
  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;

      /* Primero, el nombre de la linea de despacho. El CSS ya le quita
         el puntero, asi que con el mouse no se llega; esto cubre el
         teclado, porque un enlace con pointer-events:none igual recibe
         foco y Enter le dispara un click. */
      if (e.target.closest(ENLACE_DESPACHO)) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      var btn = e.target.closest('[name="checkout"]');
      if (!btn) return;

      var cajon = btn.closest(CAJON);
      if (!cajon || hayEntrega(cajon)) return;

      e.preventDefault();
      e.stopPropagation();
      window.location.href = '/cart';
    },
    true
  );

  /* Y se saca del orden de tabulacion, para que el foco no se pose en
     algo que no hace nada. */
  function soltarEnlaces() {
    var enlaces = document.querySelectorAll(ENLACE_DESPACHO);
    for (var i = 0; i < enlaces.length; i++) {
      if (enlaces[i].getAttribute('tabindex') === '-1') continue;
      enlaces[i].setAttribute('tabindex', '-1');
      enlaces[i].setAttribute('aria-disabled', 'true');
    }
  }

  /* Cambia solo la etiqueta. El tema la envuelve en
     .button-text; si algun dia deja de hacerlo, se cae al
     primer nodo de texto y sigue funcionando. */
  function renombrar(btn) {
    var span = btn.querySelector('.button-text');
    if (span) {
      span.textContent = TEXTO_BOTON;
      return true;
    }
    for (var i = 0; i < btn.childNodes.length; i++) {
      var n = btn.childNodes[i];
      if (n.nodeType === 3 && n.nodeValue.trim().length > 1) {
        n.nodeValue = TEXTO_BOTON;
        return true;
      }
    }
    return false;
  }

  function vestir() {
    var cajon = document.querySelector(CAJON);
    if (!cajon || hayEntrega(cajon)) return;

    var btn = cajon.querySelector('[name="checkout"]');
    if (btn && btn.getAttribute('data-bh-listo') !== '1') {
      if (renombrar(btn)) btn.setAttribute('data-bh-listo', '1');
    }

    var ctas = cajon.querySelector('.cart__ctas');
    if (ctas && !cajon.querySelector('.bh-carrito__paso')) {
      var p = document.createElement('p');
      p.className = 'bh-carrito__paso';
      p.textContent = TEXTO_PASO;
      ctas.insertAdjacentElement('afterend', p);
    }
  }

  function arrancar() {
    vestir();
    soltarEnlaces();

    /* El carrito se repinta con cada cambio, en el cajon y en la
       pagina, y cada repintado trae filas nuevas del servidor sin el
       tabindex. Se mira todo el cuerpo porque las filas viven en dos
       lugares distintos segun la pagina. El trabajo por pasada es un
       querySelectorAll acotado, y se agrupa en una microtarea para no
       correrlo una vez por nodo. */
    if (!('MutationObserver' in window)) return;

    var pendiente = false;
    new MutationObserver(function () {
      if (pendiente) return;
      pendiente = true;
      Promise.resolve().then(function () {
        pendiente = false;
        vestir();
        soltarEnlaces();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
